import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Shield, Trash } from "@phosphor-icons/react";

export default function KVKK() {
  const [text, setText] = useState("");
  const [days, setDays] = useState(365);
  const [cleanupResult, setCleanupResult] = useState(null);

  const load = async () => {
    const { data } = await api.get("/settings");
    setText(data.kvkk_text || "");
    setDays(data.retention_days || 365);
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.put("/settings", { kvkk_text: text, retention_days: Number(days) });
      toast.success("KVKK ayarları kaydedildi");
    } catch (e) { toast.error(e?.response?.data?.detail || "Kaydedilemedi"); }
  };

  const cleanup = async () => {
    if (!window.confirm(`Saklama süresi (${days} gün) dolan kayıtlar silinsin mi? Bu işlem geri alınamaz.`)) return;
    try {
      const { data } = await api.post("/kvkk/cleanup-now");
      setCleanupResult(data);
      toast.success(
        `Temizlik tamam: ${data.camera_reads_deleted} kamera + ` +
        `${data.audit_logs_deleted} log + ${data.sessions_image_purged} plaka görüntüsü`
      );
    } catch (e) { toast.error(e?.response?.data?.detail || "Temizlik başarısız"); }
  };

  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Gizlilik</div>
        <h1 className="text-3xl md:text-4xl font-bold tracking-tight">KVKK & Veri Saklama</h1>
      </div>

      <Card className="rounded-sm border-border">
        <CardContent className="p-6 space-y-4">
          <div className="flex items-center gap-2">
            <Shield size={22} weight="fill" className="text-primary" />
            <h3 className="font-semibold uppercase tracking-widest text-sm">Aydınlatma Metni</h3>
          </div>
          <p className="text-xs text-muted-foreground">
            Müşterilere gösterilen aydınlatma metni. Kayıt sırasında ve müşteri sayfalarında görüntülenebilir.
          </p>
          <Textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            rows={8}
            className="rounded-sm text-sm"
            placeholder="KVKK aydınlatma metnini yazın..."
            data-testid="kvkk-text"
          />
        </CardContent>
      </Card>

      <Card className="rounded-sm border-border">
        <CardContent className="p-6 space-y-4">
          <h3 className="font-semibold uppercase tracking-widest text-sm">Veri Saklama Süresi</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <Label>Saklama süresi (gün)</Label>
              <Input type="number" min="30" value={days} onChange={(e) => setDays(e.target.value)} className="rounded-sm font-mono" data-testid="kvkk-days" />
              <div className="text-xs text-muted-foreground mt-1">Bu süreden eski kamera okuma, denetim kaydı otomatik silinir; eski oturumların plaka görüntüleri temizlenir.</div>
            </div>
            <div className="flex items-end">
              <div className="text-xs text-muted-foreground">Otomatik temizlik günlük saat 03:00'te çalışır (Europe/Istanbul).</div>
            </div>
          </div>
          <div className="flex gap-2">
            <Button onClick={save} className="rounded-sm bg-primary text-primary-foreground hover:bg-primary/90 uppercase tracking-widest font-semibold" data-testid="kvkk-save-btn">
              Kaydet
            </Button>
            <Button variant="outline" onClick={cleanup} className="rounded-sm uppercase tracking-widest font-semibold" data-testid="kvkk-cleanup-btn">
              <Trash size={16} /> Şimdi Temizle
            </Button>
          </div>

          {cleanupResult && (
            <div className="p-3 bg-muted rounded-sm text-xs space-y-1">
              <div className="font-semibold uppercase tracking-widest">Son Temizlik Sonucu</div>
              <div>Silinen kamera okumaları: <span className="font-mono">{cleanupResult.camera_reads_deleted}</span></div>
              <div>Silinen denetim kayıtları: <span className="font-mono">{cleanupResult.audit_logs_deleted}</span></div>
              <div>Temizlenen oturum görüntüleri: <span className="font-mono">{cleanupResult.sessions_image_purged}</span></div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
